import { toast } from 'react-toastify';

import qs from 'querystring';
import { takeLatest, call, put, all } from 'redux-saga/effects';

import { t } from '~/helpers';
import api from '~/services/api';
import history from '~/services/history';

import {
    successInRequest,
    failedRequest,
} from './actions';

export function* requestAuditoria({ payload }) {
    try {
        const { params } = payload;
        const response = yield call(api.get, 'auditoria', {
            params,
            paramsSerializer: (param) => qs.stringify(param),
        });
        const { items, page, pageSize, totalCount, totalPages } = response.data;

        yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
    } catch (erros) {
        yield put(failedRequest());
        erros.map((error) => toast.error(error));
    }
}


export function* applyedFilters({ payload }) {
    try {
        const { params } = payload;

        const response = yield call(api.get, 'auditoria', {
            params,
            paramsSerializer: (param) => qs.stringify(param),
        });

        const { items, page, pageSize, totalCount, totalPages } = response.data;

        yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
    } catch (erros) {
        yield put(failedRequest());
        erros.map((error) => toast.error(error));
    }
}

export default all([
    takeLatest('@auditoria/AUDITORIA_IN_REQUEST', requestAuditoria),
    takeLatest('@auditoria/SUCCESS_REMOVE', requestAuditoria),
    takeLatest('@auditoria/RECORD_FILTERING', applyedFilters),
]);
